
export default {
  namespaced: true,
  state() {
    return {
      records: []
    }
  },
  getters: {
    records(state){
      return state.records
    },
    record(state){
      return state.records.length == 0 ? null : state.records[0]
    },
    getRecord(state, key_string, key_value){
      let a = state.records.filter(record => record['key_name'] == key_value)
      return a != null ? a : null
    }
  },
  mutations: {
    setRecords(state, payload){
      state.records = payload
    }
  },
  actions: {
    fetch({ commit }, model_name){
      var url, record_name;

      if(typeof model_name == "string") {
        url = `/api/v1/${model_name}.json`
        record_name = model_name
      }
      else if(model_name instanceof Array) {
        if(model_name.length == 2){
          url = `/api/v1/${model_name[0]}/${model_name[1]}.json`
        }else if(model_name.length == 3){
          if(model_name[1] == null){
            url = `/api/v1/${model_name[0]}.json`
          }else {
            url = `/api/v1/${model_name[0]}/${model_name[1]}.json`
          }
          if(model_name[2]){
            var option = model_name[2]
            if(option['query']){ url += `?${option['query']}` }
            if(option['record_name']){ record_name = option['record_name']  }
          }
        }
        if(record_name == null){
          record_name = model_name[0]
        }
      }

      this.$http.get(url)
          .then(({data}) => {
            if(data[record_name] instanceof Array) {
              commit('setRecords', Object.assign([], data[record_name]))
            }else{
              var d = [ Object.assign({}, data[record_name]) ]
              commit('setRecords', Object.assign([], d))
            }
          })
          .catch((error) => {
            commit('setRecords', Object.assign([], []))
            throw error
          })
    }
  }
}